export default [
  {
    path: '/sistema/tenants',
    name: 'sistema-tenants',
    component: () => import('@/views/sistema/tenants/Index.vue'),
    meta: {
      pageTitle: 'Gestão de Tenants',
      action: 'read',
      resource: 'Sistema',
      adminDkpOnly: true,
    },
  },
];
